module.exports = __webpack_public_path__ + "img/en_tis60_3.720dabee.png";